import $api from "../http";

export default class SystemUserService {

    static async getSystemUser(paginationModel, filterModel) {
        return $api.get(`/system_users`, {
            params: {
                page: paginationModel.page,
                page_size: paginationModel.pageSize,
                provider: filterModel.provider,
                group: filterModel.group,
                open: filterModel.open,
                close: filterModel.close,
                filter: filterModel.filter,
            }
        })
    }

    static async putSystemUser(systemUser) {
        return $api.put(`/system_users/${systemUser.id}`, {systemUser})
    }

    static async getSystemUserReportWorkShift(provider_id, time_start, time_end) {
        return $api.get(`/system_users/${provider_id}/report_work_shift`, {'params': {'time_start': time_start, 'time_end': time_end}})
    }
    
}